import React from 'react';

const Mobile = () => {
  return <div></div>;
};

export default Mobile;
